var hcMainDefaultVertical = null;

hcMainDefaultVertical = new Swiper('.hc-main-slider-vertical', {
  direction: 'horizontal',
  loop: false,
  slidesPerView: 1,
  slidesPerScroll: 1,
  speed: 600,
  centeredSlides: true,
  autoHeight: true,
  pagination: { el: ".swiper-pagination" },
  navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' },
  effect: 'fade',
  fadeEffect: { crossFade: true }
});

if ($('.hc-main-slider-vertical').length && window.innerWidth <= 768) {
  var $rootVertical = $('.hc-main-slider-vertical');
  var hcVariantsVertical = $rootVertical.attr('data-variants');
  if (hcVariantsVertical != '1') {
    var hcMainSlidesDefVertical = [];
    $rootVertical.find('.swiper-slide').each(function () { hcMainSlidesDefVertical.push($(this)); });
    function normVertical(vVertical) {
      var v = (vVertical || '').toString().trim().toLowerCase();
      v = v.replace(/ø/g,'o').replace(/æ/g,'ae').replace(/å/g,'a');
      if (v.normalize) v = v.normalize('NFD').replace(/[\u0300-\u036f]/g,'');
      return v.replace(/[^a-z0-9\s-]/g,'').replace(/\s+/g,'-');
    }
    var hcMapRawInit = ($rootVertical.attr('data-hc-map-no-en') || '');
    var hcTranslateInit = {};
    hcMapRawInit.split(',').forEach(function(pair) {
      var parts = pair.split(':');
      if (parts.length === 2) hcTranslateInit[parts[0]] = parts[1];
    });
    function resolveVertInit(token) { return hcTranslateInit[token] || token; }
    var optionsCountVertical = parseInt($rootVertical.attr('data-options') || '1', 10);
    var hcValuesVertical = [];
    if (optionsCountVertical > 1) {
      for (var iVertical = 0; iVertical < optionsCountVertical; iVertical++) {
        var valVertical = $rootVertical.attr('data-value-' + iVertical);
        if (valVertical) hcValuesVertical.push(resolveVertInit(normVertical(valVertical)));
      }
    } else {
      var v0Vertical = $rootVertical.attr('data-value') || $rootVertical.attr('data-value-0');
      if (v0Vertical) hcValuesVertical.push(resolveVertInit(normVertical(v0Vertical)));
    }
    $(hcMainSlidesDefVertical).each(function () {
      var $slideVertical = $(this);
      var keepVertical = hcValuesVertical.length > 0;
      for (var jVertical = 0; jVertical < hcValuesVertical.length; jVertical++) {
        if (!$slideVertical.hasClass('hc-' + hcValuesVertical[jVertical])) { keepVertical = false; break; }
      }
      if (keepVertical) { hcMainDefaultVertical.appendSlide(this); } else { $slideVertical.remove(); }
    });
    hcMainDefaultVertical.update();
    hcMainDefaultVertical.slideTo(0, false);
  }
  $('.hc-main-slider-vertical').removeClass('hc-loading');
}

function isMobileWidth() { return window.innerWidth <= 768; }

function initVerticalIfNeeded() {
  if (!hcMainDefaultVertical && $('.hc-main-slider-vertical').length) {
    hcMainDefaultVertical = new Swiper('.hc-main-slider-vertical', {
      direction: 'horizontal',
      loop: false,
      slidesPerView: 1,
      slidesPerScroll: 1,
      speed: 600,
      centeredSlides: true,
      autoHeight: true,
      pagination: { el: ".swiper-pagination" },
      navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' },
      effect: 'fade',
      fadeEffect: { crossFade: true }
    });
  }
}

function destroySwiperInstance(instance, selector) {
  if (instance && instance.destroy) { instance.destroy(true, true); }
  var el = document.querySelector(selector);
  if (el) el.classList.remove('swiper-initialized', 'swiper-horizontal', 'swiper-vertical');
  return null;
}

function handleSwiper() {
  if (isMobileWidth()) {
    initVerticalIfNeeded();
    if (hcMainDefaultVertical) { hcMainDefaultVertical.update(); hcMainDefaultVertical.slideTo(0, false); }
  } else {
    hcMainDefaultVertical = destroySwiperInstance(hcMainDefaultVertical, '.hc-main-slider-vertical');
  }
}

if ($('.hc-main-slider-vertical').length) {
  handleSwiper();
}
window.addEventListener('resize', handleSwiper);
